import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RelatorioDTO } from '../../../../dtos/relatorio-dto';
import { Filial } from '../../../../filial/filial';
import { FilialService } from '../../../../filial/filial.service';
import { Medico } from '../../../../medico/medico';
import { MedicoService } from '../../../../medico/medico.service';
import { ProcedimentoConsulta } from '../../../../procedimento/procedimento-consulta/procedimento-consulta';
import { ProcedimentoConsultaService } from '../../../../procedimento/procedimento-consulta/procedimento-consulta.service';
import { RelatorioConsultaService } from '../../relatorio-consulta.service';

@Component({
  selector: 'app-rel-marcacao-consulta',
  templateUrl: './rel-marcacao-consulta.component.html',
  styleUrls: ['./rel-marcacao-consulta.component.css']
})
export class RelMarcacaoConsultaComponent implements OnInit {

  formularioDeMarcacaoDeConsultas: FormGroup;

  listaFiliais: Filial[];

  listaDeProcedimentoConsulta: ProcedimentoConsulta[];

  listaDeMedicos: Medico[];

  constructor(private relatorioService: RelatorioConsultaService,
    private filialService: FilialService,
    private procedimentoConsultaService: ProcedimentoConsultaService,
    private medicoService: MedicoService,
    private formBuilder: FormBuilder) {

    this.formularioDeMarcacaoDeConsultas = this.formBuilder.group({
      filial: ['', [Validators.required]],
      dataInicial: ['', [Validators.required]],
      procedimentos: ['', [Validators.required]],
      medicos: [''],
    });

    this.listaFiliais = [];

    this.listaDeProcedimentoConsulta = [];

    this.listaDeMedicos = [];
  }

  ngOnInit() {

    this.listarFiliais();

    this.listarProcedimentosConsulta();

    this.listarMedicos();
  }

  onSubmit() {
    this.gerarRelatorio();
  }

  gerarRelatorio(): void {

    const relatorioDTO: RelatorioDTO = Object.assign(new RelatorioDTO(), this.formularioDeMarcacaoDeConsultas.value);

    const procedimentos: ProcedimentoConsulta[] = this.controlProcedimentos.value;
    const idsProcedimentos: number[] = [];

    procedimentos.forEach((element) => {
      idsProcedimentos.push(element.id);
    });

    relatorioDTO.idsNumberArray = idsProcedimentos;

    const medicos: Medico[] = this.controlMedicos.value;

    if (medicos) {
      const idsMedicos: number[] = [];

      medicos.forEach((element) => {
        idsMedicos.push(element.id);
      });

      relatorioDTO.idsMedicosArray = idsMedicos;
    }

    this.relatorioService.gerarRelatorioDeMarcacoes(relatorioDTO)
      .subscribe((response: BlobPart) => {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  listarFiliais() {
    this.filialService.semRelacionamento()
      .subscribe(data => {
        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }

  listarProcedimentosConsulta() {
    this.procedimentoConsultaService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaDeProcedimentoConsulta = data;

      }, error => {
        console.log(error);
      });
  }

  listarMedicos() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaDeMedicos = data;

      }, error => {
        console.log(error);
      });
  }

  get controlProcedimentos() {

    return this.formularioDeMarcacaoDeConsultas.controls.procedimentos;

  }

  get controlMedicos() {

    return this.formularioDeMarcacaoDeConsultas.controls.medicos;

  }
}
